import React from "react";
import { Typography } from "@material-ui/core";
import classes from "../../styles/CompanyLogo.module.scss";

interface CompanyLogoProps {
  name: string | undefined;
  logoUrl?: string;
}

const CompanyLogo: React.FC<CompanyLogoProps> = ({ name, logoUrl }) => {
  return (
    <div className={classes.companyLogo}>
      {logoUrl && (
        <div className={classes.logoWrapper}>
          <img className={classes.logo} src={logoUrl} alt={name} />
        </div>
      )}
      {!logoUrl && (
        <div className={classes.logoName}>
          <Typography variant="h4">{name}</Typography>
        </div>
      )}
    </div>
  );
};

export default CompanyLogo;
